import React, { ReactNode, useCallback } from 'react';

import type { Theme } from '../../themes/themes';
import type { HeaderBarProps } from '../HeaderBar/HeaderBar';
import { FlatTree } from './flatTree';
import { useNavigation } from './Provider';
import { Desktop } from './variants/Desktop';
import { Mobile } from './variants/Mobile';

interface NavigationProps {
  tree: FlatTree[];
  HeaderBarProps: HeaderBarProps;
  DesktopProps: {
    tabSize: 'small' | 'medium' | 'large' | 'header';
  };
  MobileProps?: {
    customPanel?: ReactNode;
    onCustomPanelBack?: () => void;
  };
  onClose?: () => void;
  createHeaderTheme: () => Theme;
}

export const Navigation: React.FC<NavigationProps> = ({
  tree,
  onClose,
  HeaderBarProps,
  DesktopProps,
  MobileProps,
  createHeaderTheme,
}) => {
  const { open, setOpen } = useNavigation();
  const handleClose = useCallback(() => {
    setOpen(false);
    onClose?.();
  }, [setOpen, onClose]);

  // Desktop need to be rendered last, so that "esc" is working, mutliple drawers don't work so good together
  return (
    <>
      <Mobile
        tree={tree}
        open={open}
        onClose={handleClose}
        HeaderBarProps={HeaderBarProps}
        MobileProps={MobileProps}
        createHeaderTheme={createHeaderTheme}
        aria-expanded={open}
      />
      <Desktop
        tree={tree}
        open={open}
        onClose={handleClose}
        HeaderBarProps={HeaderBarProps}
        DesktopProps={DesktopProps}
      />
    </>
  );
};
